import React from "react";

type PageLoadingIndicatorProps = {
  className?: string;
  message?: string;
};

const PageLoadingIndicator = ({ className = "", message = "Preparing the start line…" }: PageLoadingIndicatorProps) => {
  const classes = ["app-loading-indicator", className].filter(Boolean).join(" ");

  return (
    <div className={classes} role="status" aria-live="polite">
      <span className="app-loading-wordmark" aria-hidden="true">
        RAUXA
      </span>
      <span className="app-loading-progress" aria-hidden="true">
        <span />
      </span>
      <span className="app-loading-message">{message}</span>
    </div>
  );
};

export default PageLoadingIndicator;
